import React from 'react';
import { Button as MuiButton } from '@mui/material';

export default function Button({
    children,
    variant = 'contained',
    color = 'primary',
    size = 'medium',
    onClick,
    sx = {},
    ...props
}) {
    const defaultStyles = {
        textTransform: 'none',
        borderRadius: '8px', // Angles arrondis rectangulaires
        boxShadow: 'none', // Pas d'élévation
        '&:hover': {
            boxShadow: 'none', // Pas d'élévation au hover non plus
        },
        '&:active': {
            boxShadow: 'none',
        },
        '&:focus': {
            boxShadow: 'none',
        },
        // Styles pour le variant contained
        ...(variant === 'contained' && {
            backgroundColor: color === 'primary' ? '#0075FF' : undefined,
            '&:hover': {
                backgroundColor: color === 'primary' ? '#0056CC' : undefined,
                boxShadow: 'none',
            }
        }),
        // Fusionner avec les styles personnalisés
        ...sx
    };

    return (
        <MuiButton
            variant={variant}
            color={color}
            size={size}
            onClick={onClick}
            sx={defaultStyles}
            {...props}
        >
            {children}
        </MuiButton>
    );
}